export function isHabitCompleted(id, date, checklists){
  return checklists[id] && checklists[id].find(d => d.setHours(0,0,0,0) === date.setHours(0,0,0,0)) ? true : false;
}
